import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from 'lucide-react';
import { getRejectionLogs } from "../services/allApiService";

function RejectionLogs() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);

  const handleGoBack = () => {
    navigate("/account");
  };
   // Function to format date and time
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    // Fetch rejection logs data on component mount
    const getRejectionsLogs = async () => {
      try {
        setLoading(true);

        const data = await getRejectionLogs();

        if (data?.success === true) {
          setLogs(data?.data?.records || []);
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching rejection logs:", error);
        setLoading(false);
      }
    };
    getRejectionsLogs();
  }, [])

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="h-screen overflow-y-scroll p-4 pb-20 flex-grow max-w-sm min-w-[375px] w-full bg-white 
            [&::-webkit-scrollbar]:w-1 
            [&::-webkit-scrollbar-track]:bg-transparent 
            [&::-webkit-scrollbar-thumb]:bg-transparent 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent">
        <p className="text-sm leading-6 mb-[15px] mt-0 tracking-wide font-lato font-semibold flex items-center">
          <span className="font-black me-1">
            <ChevronLeft size={16} onClick={handleGoBack} />
          </span>
          Rejection Logs
        </p>

        {/* <div className="flex flex-col h-full">
            <img
              className="mb-5 max-w-full h-auto align-top"
              src={`${process.env.PUBLIC_URL}/orderexecuted-image.svg`}
              alt="logo"
            />
        </div> */}
        {loading ? (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
            <p className="text-gray-500 mt-4">Loading Rejection Logs...</p>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            {logs?.length > 0 ? (
              logs?.map((log) => (
                <div
                  key={log.rejection_log_id}
                  className="p-3 bg-[#ffe9ec] rounded-lg border border-gray-200 shadow-sm"
                >
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-semibold text-gray-800">{log.script_name}</span>
                    <span className="text-xs text-gray-500">
                      {formatDateTime(log.created_at)}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600">{log.message}</p>
                </div>
              )
              )) : (
              <div className="flex flex-col h-full">
                <img
                  className="mb-5 max-w-full h-auto align-top"
                  src={`${process.env.PUBLIC_URL}/orderexecuted-image.svg`}
                  alt="logo"
                />
              </div>
            )}
          </div>

        )}
      </div>
    </div>
  );
}

export default RejectionLogs;